export const TEST_ID = 'mediumText';
